import { h } from 'preact';
import * as BaseComp from 'components/bolt/movieDetails/movieDetails.js';
import Socials from 'components/bolt/socials/socials';
import { accessNested, joinClasses } from 'utils/utils';
import Store from 'store/store';
import s from 'components/bolt/movieDetails/movieDetails.sss';

export default class MovieDetails extends BaseComp.default {
	constructor(props) {
		super(props);
		this.renderAllButtons = true;
	}

	renderButtons(buttons) {
		if (!buttons) return;
		return super.renderButtons(buttons);
	}
}
